RivalIQ.apps.SocialPosts.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';


    function getDefaultMetrics(source) {
        switch (source) {
            case RivalIQ.enums.sources.FACEBOOK_INSIGHTS:
            case RivalIQ.enums.sources.INSTAGRAM_INSIGHTS:
            case RivalIQ.enums.sources.LINKEDIN:
            case RivalIQ.enums.sources.TWITTER_INSIGHTS:
            case RivalIQ.enums.sources.TIKTOK_INSIGHTS:
                return RivalIQ.apps.Insights.widgets.INSIGHTS_POST_DEFAULT_METRICS[source];

            default:
                return ['engagement_total', 'engagement_rate'];
        }
    }

    // This view is a little sad; we want a single focus company table for custom dashboards for both private and public sources. Until those two widgets are
    // unified, we have this view -- it looks at the source of the table and switches between the private and public posts tables/grid views.
    const WidgetSwitcherContainer = RivalIQ.views.LayoutView.mixin({
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },
        regions: {
            container: '.widget-container'
        },
        dashboardModelEvents: {
            'change:source': 'reload'
        },
        getTemplate: _.memoize(function () {
            return _.template($.tagHtml('div', {
                class: 'widget-container'
            }));
        }),
        onBeforeRenderLoaded: function () {
            const me = this;

            const widgetId = (RivalIQ.enums.sourceDetails[me.getProp('source')].privateData ? 'private-posts-table' : 'social-posts-table');
            const widget = me.dashboardModel.getWidget(widgetId);
            me.container.showWidget(widget);

            me.listenTo(widget, 'change:sortOrder', function (model, sortOrder) {
                me.setProps('sortOrder', sortOrder, {
                    silent: false
                });
            });

            me.listenTo(widget, 'change:orderBy', function (model, orderBy) {
                me.setProps('orderBy', orderBy, {
                    silent: false
                });
            });
        }
    });

    const CompanySocialPostsWidget = RivalIQ.apps.SocialPosts.widgets.SocialPostsWidget.extend({
        propsToOmitFromSerialization: ['companyIds', 'type', 'companyId'],

        propsToSerialize: RivalIQ.apps.SocialPosts.widgets.SocialPostsWidget.prototype.propsToSerialize.concat(['mediaTypeFilter']),

        view: WidgetSwitcherContainer,

        footerView: null, // Don't want the social posts PanelFooter here since it's not applicable to custom dashboards and can load the wrong data.

        getChartTitle: function () {
            const me = this;

            const title = me.getProp('title');

            if (title) {
                return title;
            }

            const sourceDetails = _.get(RivalIQ.enums.sourceDetails, [me.getProp('source')]);
            const sourceName = (sourceDetails && sourceDetails.source !== RivalIQ.enums.sources.CROSS_CHANNEL ?
                _.get(sourceDetails, ['name']) : null);
            const postWord = _.capitalize(`${_.get(sourceDetails, ['postName'])}s`);

            if (me.getCuration().isCustomDashboard) {
                let prefix;

                const companyId = me.getProp('companyId') || me.getProp('companyIds');
                if (companyId) {
                    prefix = RivalIQ.state.landscape.get('companies').get(companyId).get('name');
                } else {
                    prefix = 'Landscape';
                }

                return _.compact([prefix, sourceName, postWord]).join(' ');
            }

            const strName = me.getProp('companyIds') ? 'social_posts_posts_title_company' : 'social_posts_posts_title_landscape';
            return RivalIQ.str(strName, postWord);
        },

        csvExportProps: function (props) {
            const me = this;
            if (RivalIQ.enums.sourceDetails[props.source].privateData) {
                return RivalIQ.apps.Insights.widgets.MediaWidget.prototype.csvExportProps.apply(me, arguments);
            } else {
                return RivalIQ.apps.SocialPosts.widgets.SocialPostsWidget.prototype.csvExportProps.apply(me, arguments);
            }
        },

        widgetDefinitions: function () {
            return [
                {
                    instanceId: 'social-posts-table',
                    widgetId: RivalIQ.enums.widgetTypes.SOCIAL_POSTS
                },
                {
                    instanceId: 'private-posts-table',
                    widgetId: RivalIQ.enums.widgetTypes.INSIGHTS_MEDIA
                }
            ];
        },

        processProps: function (props) {
            const me = this;

            if (!_.isFinite(props.source)) {
                props.source = RivalIQ.enums.sources.CROSS_CHANNEL;
                if (props.channel) {
                    props.source = RivalIQ.data.channels.get(props.channel).get('source');
                }
            }

            if (RivalIQ.enums.sourceDetails[props.source].privateData) {
                _.extend(props, {
                    useUniversalMetricsApi: true,
                    objectType: 'post',
                    channel: RivalIQ.data.channels.get(props.source).get('channel')
                });

                if (!RivalIQ.state.plan.get('has_multi_handle_private_advanced')) {
                    props.companyId = props.focusCompanyId;
                }
            } else {
                if (props.type && _.isUndefined(props.mediaTypeFilter)) {
                    props.mediaTypeFilter = props.type;
                }
                _.extend(props, {
                    useUniversalMetricsApi: false,
                    type: props.mediaTypeFilter // type is the prop social posts uses for this filter
                });
            }

            return RivalIQ.apps.SocialPosts.widgets.SocialPostsWidget.prototype.processProps.apply(me, arguments);
        },

        getBuilderFields: function () {
            const me = this;

            const fields = [
                {
                    type: 'source_only',
                    onChange: function (source) {
                        const me = this;
                        const metric = me.dashboardModel.baseMetric;

                        const channel = RivalIQ.data.channels.get(source);
                        let channelName = channel.get('channel');
                        if (channel.isCrossChannel()) {
                            channelName = undefined;
                        }

                        const newProps = {
                            channel: channelName,
                            source: source
                        };

                        const mediaTypeFilter = me.dashboardModel.getProp('mediaTypeFilter');
                        if (mediaTypeFilter) {
                            const filterNotApplicable = !_.find(App.utils.getPostMediaTypeFilterItems(source), {
                                id: mediaTypeFilter
                            });
                            if (filterNotApplicable) {
                                newProps.mediaTypeFilter = undefined;
                            }
                        }

                        metric.channel = channelName;
                        me.dashboardModel.setProps(newProps, {
                            silent: false,
                            navigate: false
                        });
                        me.dashboardModel.setBaseMetric(metric);
                    },
                    size: 3
                },
                {
                    type: 'postFilter',
                    size: 9
                },
                {
                    type: 'postType',
                    prop: 'mediaTypeFilter',
                    items: function () {
                        return App.utils.getPostMediaTypeFilterItems(me.getProp('source'));
                    },
                    onBaseMetricChanged: function (view) {
                        view.reload();
                    }
                },
                {
                    type: 'layout',
                    size: 3
                },
                {
                    type: 'postTagIds',
                    size: 3,
                    onBaseMetricChanged: function (view) {
                        view.reload();
                    }
                },
                {
                    type: 'postTagVisibility',
                    size: 3,
                    onBaseMetricChanged: function (view) {
                        view.reload();
                    }
                },
                {
                    type: 'metrics',
                    size: 12,
                    title: 'Metrics',
                    loadData: function () {
                        const field = this;

                        const props = me.getProps();

                        if (props.source === RivalIQ.enums.sources.INSTAGRAM_INSIGHTS) {
                            // need to load metadata to see if this account has access to paid metrics.
                            return RivalIQ.data.privateMetadata.fetch(props)
                                .then(function (metadata) {
                                    const company = _.find(metadata.companies, function (company) {
                                        return (company.id === props.companyId);
                                    });
                                    me.curation.presence = new Backbone.Model(company);
                                    me._updateValidMetricsForBuilder(field);
                                });
                        } else {
                            // for the other channels, we don't need any other info to decide what the metrics should be.
                            me._updateValidMetricsForBuilder(field);
                            return $.when();
                        }
                    },
                    onBaseMetricChanged: function (view) {
                        // update the view with new source metrics before we reload
                        const model = view.dashboardModel;
                        const metrics = RivalIQ.apps.Insights.views.TableMetricChooser.prototype.getMetricsCollection.call(me);
                        if (!me.areAllMetricsValid(metrics)) {
                            const defaultMetrics = getDefaultMetrics(model.getProp('source'));
                            const newMetrics = _.map(defaultMetrics, function (property) {
                                return {
                                    property: property
                                };
                            });
                            model.setProps({
                                metrics: newMetrics
                            }, {
                                navigate: false
                            });
                        }
                        view.reload();
                    }
                }
            ];

            return fields;
        },

        _updateValidMetricsForBuilder: function (field) {
            const me = this;

            // We need to get the metrics via table metric chooser (instead of just looking at props) because we do some metric remapping there
            // if the user has access to ads and this is instagram insights.
            const metrics = RivalIQ.apps.Insights.views.TableMetricChooser.prototype.getMetricsCollection.call(me);

            field.set({
                metrics: metrics
            });
        },

        showPrivateSources: function () {
            const hasMultiPrivateChannel = RivalIQ.state.plan.get('has_multi_handle_private_advanced');
            return hasMultiPrivateChannel;
        },

        getValidChannels: function () {
            const me = this;

            const publicChannelsWithSearch = RivalIQ.data.channels.withSearch().withAccess().notHidden(true);
            const privateChannelsWithSearch = _.keyBy(RivalIQ.data.channels.withPrivatePostsData().withAccess().notHidden(true).map('id'));
            const shouldShowPrivateSources = me.showPrivateSources();

            return RivalIQ.data.channels.filter(function (channel) {
                const source = channel.id;
                if (shouldShowPrivateSources && RivalIQ.enums.sourceDetails[source].privateData) {
                    return !_.isUndefined(privateChannelsWithSearch[source]);
                }

                return Boolean(publicChannelsWithSearch.get(source));
            });
        }
    });

    const FocusCompanySocialPostsWidget = CompanySocialPostsWidget.extend({
        processProps: function (props) {
            const me = this;

            props = CompanySocialPostsWidget.prototype.processProps.apply(me, arguments);

            if (RivalIQ.enums.sourceDetails[props.source].privateData) {
                _.extend(props, {
                    companyId: props.focusCompanyId
                });
            } else {
                _.extend(props, {
                    companyIds: props.focusCompanyId
                });
            }

            props.useUniversalMetricsApi = false;

            return props;
        },

        showPrivateSources: _.constant(true)
    });

    FocusCompanySocialPostsWidget.prepare = CompanySocialPostsWidget.prepare = function (props) {
        const isWidgetEditMode = Boolean(props.focusWidgetInstanceId);
        if (isWidgetEditMode || (props.source && RivalIQ.enums.sourceDetails[props.source].privateData)) {
            return RivalIQ.apps.Insights.widgets.MediaWidget.prepare(props);
        } else {
            return $.when();
        }
    };

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.MEDIA_WIDGET, CompanySocialPostsWidget);
    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.FOCUS_COMPANY_SOCIAL_POSTS, FocusCompanySocialPostsWidget);
});
